/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component, FormEvent, ReactNode } from 'react';
import { AppState } from '../../app.state';
import { User, _User } from '../../_shared/interfaces/user';
import { Alert, Modal, message } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import FormTitle from '../../_shared/form-title';
import styles from './edit-org.styles';
import { Button } from '../../_shared/button';
import {
  buildErrorMsgFromForm,
  uppercaseFirst,
  userHasRole,
  uppercaseWords,
  validPhoneNumber,
  sortByName,
  getMyOrg,
  hasSubHistory,
  setTrialSub,
  setPayedSub,
  cleanPhoneNumber,
  isHandpiece,
  cleanCopy,
  stopProp,
} from '../../utils';
import Link from '../../_shared/link';
import { get, set, flatten, chain, uniqBy, sortBy, size } from 'lodash';
import { Org, _Org } from '../../_shared/interfaces/org';
import NumberedHeader from '../../_shared/numbered-header';
import SharedStyles from '../../_shared/styles';
import {
  getEquipments,
  createOrUpdateEquipment,
} from '../../_shared/services/manage-equipment.service';
import { TableTransfer } from '../../_shared/table-transfer';
import {
  equipmentTransferColumns,
  equipmentTransferFilterOption,
} from '../../_shared/table-transfer/equipment-columns';
import { Equipment } from '../../_shared/interfaces/equipment';
import { getModels } from '../../_shared/services/manage-models.service';
import { _Model, Model } from '../../_shared/interfaces/model';
import {
  createOrg,
  getOrgs,
  updateOrg,
} from '../../_shared/services/manage-orgs.service';
import {
  getUser,
  createUser,
  getUsers,
  updateUser,
} from '../../_shared/services/manage-users.service';
import { Emails } from '../../_shared/lib/emails';
import { sendEmail } from '../../_shared/services/email.service';
import React from 'react';
import moment from 'moment';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { _Location } from '../../_shared/interfaces/location';
import { createLocation } from '../../_shared/services/manage-locations.service';
import { Opt } from '../../_shared/interfaces/opt';
import { SelectValue } from 'antd/lib/select';
import { DentalOrgType } from '../../_shared/interfaces/dentalOrgType';
import { getAppSettings } from '../../_shared/services/manage-app-settings.service';
import {
  handpieceSyncStartedMessage,
  syncHandpiecesInBackground,
} from '../../_shared/services/handpiece-profiles.service';
import { sendDeviceCommand } from '../../_shared/services/manage-schedule.service';
import { trackEvent, } from '../../_shared/services/analytics.service';
import eventTypes from '../../_shared/interfaces/api/eventTypes';
import { StatesSelect } from '../../_shared/lib/states';
import { WithForm } from '../../_shared/form';
import { WithAppConfig } from '../../_shared/hooks/useAppConfig';

interface IProps extends RouteComponentProps {
  sState: AppState;
  updateUser: (user: User) => Promise<User>;
  getUserData: () => Promise<{}>;
  updateOrgs: () => void;
  updateLocations: () => void;
  form?: any;
  app?: any;
}

interface TDisplay {
  title?: string;
  var: string;
  style?: string;
  canDisplay?: () => boolean;
  transform?: (value: string) => string;
  options?: any;
  data?: () => string[];
  opts?: Opt[] | (() => Opt[]);
  type?: string;
  value?: string;
  checked?: boolean;
  label?: string;
  subText?: (item: TDisplay) => string;
  onChange?: (e: CheckboxChangeEvent | FormEvent) => void;
  onSelect?: (value: SelectValue) => void;
  disabled?: boolean;
  props?: {};
}

export class _EditOrgComponent extends Component<IProps> {
  // AER-1721: the handpieces `addEquipment` has successfully assigned, waiting to be
  // pushed to. They are held here rather than returned so that the push can be run after
  // the organization has been written -- see `syncAddedHandpieces`.
  handpiecesPendingSync: Equipment[] = [];

  // tslint:disable-next-line: no-any
  state: any = {
    loading: false,
    checked: true,
    org: undefined,
    orgType: undefined,
    back: undefined,
    canLeave: false,
    isAssignEquipment: false,
    nextLocation: '',
    locationName: '',
    screen: 0,
    equipment: [] as Equipment[],
    allEquipment: [] as Equipment[],
    selectedEquipment: [] as string[],
    originalSelectedEquip: [] as string[],
    allUsers: [] as User[],
    eMap: {} as { [key: string]: Equipment },
    trialDuration: undefined,
    toDisplay: [
      [
        {
          title: 'Service Org Name',
          var: 'name',
          canDisplay: () => get(this, 'state.orgType') === 0,
          transform: (value: string) => uppercaseWords(value),
          options: {
            preserve: true,
            rules: [
              {
                required: true,
                message: 'Service Org Name is required. ',
              },
              {
                max: 50,
                message: 'Service Org Name is limited to 50 characters. ',
              },
            ],
          },
        },
        {
          title: 'Dental Org Name',
          var: 'name',
          canDisplay: () => get(this, 'state.orgType') === 1,
          transform: (value: string) => uppercaseWords(value),
          options: {
            preserve: true,
            rules: [
              {
                required: true,
                message: 'Dental Org Name is required. ',
              },
              {
                max: 50,
                message: 'Dental Org Name is limited to 50 characters. ',
              },
            ],
          },
        },
        {
          title: 'Organization Type',
          var: 'doType',
          type: 'dropdown',
          canDisplay: () => get(this.state, 'orgType') === 1,
          opts: () => sortBy(
            get(this.props, 'sState.dash.dentalOrgTypes', []),
            'id'
          ).map((dot: DentalOrgType) => {
            return { label: dot.name, value: dot.value };
          }),
          options: {
            preserve: true,
            initialValue: 'dentalPractice',
            rules: [
              { required: true, message: 'Organization Type is required.' },
            ],
          },
        },
        {
          title: 'Account ID',
          var: 'accountNumber',
          canDisplay: () => userHasRole([0, 1], this.props.sState),
          // transform: (value: string) => uppercaseWords(value),
          options: {
            preserve: true,
            rules: [
              {
                max: 20,
                message: 'Account ID limited to 20 characters. ',
              },
            ],
          },
        },
        {
          title: 'Service Org',
          var: 'serviceOrgId',
          type: 'dropdown',
          required: () => false,
          onSelect: (value: SelectValue) => {
            const orgId: string = value as string;
            this.retrieveEquipment(orgId);
          },
          canDisplay: () => {
            return (
              userHasRole([0, 1], this.props.sState) &&
              get(this, 'state.orgType') === 1
            );
          },
          transform: (v: string | number) => (v === -1 ? null : v),
          opts: () => [
            { name: 'No Service Org', id: -1, orgType: 0 },
            ...this.props.sState.dash.orgs.sort(sortByName),
          ]
            .filter(l => l.orgType === 0)
            .map(l => ({
              value: l.id,
              label: l.name || '',
            })),
          value: '',
          options: {
            preserve: true,
            rules: [
              {
                required: true,
                message: 'Service Org is required. ',
              },
            ],
          },
        },
        {
          title: 'Code',
          var: 'code',
          options: {
            preserve: true,
            rules: [
              {
                max: 10,
                message: 'Code is limited to 10 characters. ',
              },
            ],
          },
        },
        {
          title: 'Email',
          var: 'email',
          transform: (value: string) => (value || '').toLowerCase(),
          canDisplay: () =>
            get(this, 'state.orgType') === 0 ||
            (get(this, 'state.orgType') === 1 && this.state.org),
          options: {
            preserve: true,
            validateTrigger: 'onBlur',
            rules: [
              {
                type: 'email',
                message: 'The input is not a valid E-mail. ',
              },
            ],
          },
        },
        {
          title: 'Phone',
          var: 'phone',
          transform: (value: string) => cleanPhoneNumber(value),
          options: {
            preserve: true,
            validateTrigger: 'onBlur',
            rules: [
              {
                // tslint:disable-next-line:no-any
                validator: (rule: any, value: string, cb: any) => {
                  const passes = !value || validPhoneNumber(value);
                  cb(passes ? undefined : rule.message);
                },
                message: 'Phone needs to be a valid phone number. ',
              },
            ],
          },
        },
      ],
      [
        {
          title: 'Address',
          var: 'address.address',
          options: {
            preserve: true,
          },
        },
        {
          title: 'Address 2',
          var: 'address.address2',
          options: {
            preserve: true,
          },
        },
        {
          title: 'City',
          var: 'address.city',
          options: {
            preserve: true,
          },
        },
        {
          title: 'State',
          var: 'address.state',
          type: 'dropdown',
          opts: StatesSelect,
          style: `
            float: left;
            width: 50%;
            padding-right: 5px;
          `,
          options: {
            preserve: true,
          },
        },
        {
          title: 'ZIP Code',
          var: 'address.zip',
          style: `
            float: left;
            width: 50%;
            padding-left: 5px;
          `,
          options: {
            preserve: true,
          },
        },
        {
          label: 'Add Primary Location at same address',
          type: 'checkbox',
          var: 'locationPlan.checked',
          options: {
            preserve: true,
            valuePropName: 'checked',
            initialValue: true,
          },
          style: `top: 35px; clear: both;`,
          canDisplay: () =>
            get(this, 'state.orgType') === 1 && !get(this, 'state.org'),
        },
        {
          title: 'Location Name',
          var: 'locationPlan.name',
          style: `top: 35px;`,
          canDisplay: () => {
            return (
              this.props.form.getFieldValue('locationPlan.checked') &&
              get(this, 'state.orgType') === 1 &&
              !get(this, 'state.org')
            );
          },
          // tslint:disable-next-line: no-any
          onChange: (e: any) => {
            this.setState({ locationName: e.target.value });
          },
          options: {
            validateTrigger: 'onBlur',
            initialValue: get(this, 'state.locationName', ''),
            rules: [
              {
                required: true,
                message:
                  'Location name is required if add location checkbox is checked.',
              },
              {
                max: 50,
                message: 'Location name is limited to 50 characters.',
              },
            ],
          },
        },
      ],
    ],

    toDisplay1: [
      {
        title: 'Service Org Purchase Order #',
        var: 'soPurchaseOrder',
        canDisplay: () => get(this, 'state.orgType') === 0,
        options: {
          preserve: true,
          rules: [
            {
              max: 50,
              message:
                'Service Org Purchase Order # is limited to 50 characters. ',
            },
          ],
        },
      },
      {
        title: 'Dental Org Purchase Order #',
        var: 'doPurchaseOrder',
        canDisplay: () => get(this, 'state.orgType') === 1,
        options: {
          preserve: true,
          rules: [
            {
              max: 50,
              message:
                'Dental Org Purchase Order # is limited to 50 characters. ',
            },
          ],
        },
      },
      {
        var: 'onConsignment',
        type: 'checkbox',
        title: 'Equipment is on Consignment',
        canDisplay: () => get(this, 'state.orgType') === 0,
        options: {
          preserve: true,
          valuePropName: 'checked',
          initialValue: false,
        },
      },
    ] as TDisplay[],

    formValues: {},
    toDisplay2: [
      {
        title: 'Do not create Admin user',
        type: 'checkbox',
        var: 'adminUser.checked',
        options: {
          preserve: false,
          valuePropName: 'checked',
          // AER-1664: default this checkbox to UNCHECKED so the admin user fields
          // are visible by default when the user reaches this step. The previous
          // value was a function `() => ... ? true : false`; rc-field-form (AntD6)
          // stores `initialValue` as a literal (it never invokes functions), and a
          // function object is always truthy — so the box always rendered CHECKED.
          // That, combined with `canDisplay: () => !getFieldValue('adminUser.checked')`
          // returning true on the first paint (before the field registers its
          // initial value), produced the "flash": the admin fields appeared for a
          // frame and then hid. A literal `false` keeps the fields visible from the
          // first paint onward (no flash). When the user DOES check the box, the
          // fields hide immediately (canDisplay re-runs on the value change) and
          // submit() skips user creation via `!getFieldValue('adminUser.checked')`.
          initialValue: false,
        },
        style: `clear: both;`,
      },
      {
        title: 'First Name',
        var: 'adminUser.firstName',
        canDisplay: () => {
          return !this.props.form.getFieldValue('adminUser.checked');
        },
        transform: (value: string) => uppercaseFirst(value),
        onChange: e => {
          set(
            this,
            `state.formValues.adminUser.firstName`,
            get(e, 'target.value')
          );
        },
        options: {
          rules: [
            {
              required: true,
              message: 'Name is required. ',
            },
            {
              max: 50,
              message: 'Name is limited to 50 characters. ',
            },
          ],
        },
      },
      {
        title: 'Last Name',
        var: 'adminUser.lastName',
        canDisplay: () => !this.props.form.getFieldValue('adminUser.checked'),
        transform: (value: string) => uppercaseFirst(value),
        onChange: e => {
          set(
            this,
            `state.formValues.adminUser.lastName`,
            get(e, 'target.value')
          );
        },
        options: {
          rules: [
            {
              required: true,
              message: 'Name is required. ',
            },
            {
              max: 50,
              message: 'Name is limited to 50 characters. ',
            },
          ],
        },
      },
      {
        title: 'Email',
        var: 'adminUser.email',
        canDisplay: () => !this.props.form.getFieldValue('adminUser.checked'),
        transform: (value: string) => (value || '').toLowerCase(),
        onChange: e => {
          set(this, `state.formValues.adminUser.email`, get(e, 'target.value'));
        },
        options: {
          validateTrigger: 'onBlur',
          rules: [
            {
              type: 'email',
              message: 'The input is not a valid E-mail. ',
            },
            {
              required: true,
              message: 'The input is not a valid E-mail. ',
            },
          ],
        },
      },
      {
        title: 'Phone',
        var: 'adminUser.phone',
        canDisplay: () => !this.props.form.getFieldValue('adminUser.checked'),
        onChange: e => {
          set(this, `state.formValues.adminUser.phone`, get(e, 'target.value'));
        },
        options: {
          validateTrigger: 'onBlur',
          rules: [
            {
              // tslint:disable-next-line:no-any
              validator: (rule: any, value: string, cb: any) => {
                const passes = !value || validPhoneNumber(value);
                cb(passes ? undefined : rule.message);
              },
              message: 'Phone needs to be a valid phone number. ',
            },
          ],
        },
      },
    ] as TDisplay[],
  };

  submit = async (e: MouseEvent | FormEvent) => {
    stopProp(e);
    if (this.state.loading) {
      return;
    }

    this.state.loading = true;
    this.setState(this.state);

    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        message.error(error);
        return this.setState({ loading: false });
      }
      try {
        const {
          toDisplay,
          toDisplay1,
          toDisplay2,
          orgType,
          org,
          selectedEquipment,
        } = this.state;
        const { sState } = this.props;
        const me = new _User(get(sState, 'auth.user')) as User;
        const myOrg = getMyOrg(sState);
        const isEdit = org ? true : false;

        const originalOrg = cleanCopy(org);

        //get data plugged into necessary org and user
        const _org = new _Org(org) as Org;
        const user = new _User() as User;
        const _location = new _Location();

        flatten([...toDisplay, ...toDisplay1, ...toDisplay2] as TDisplay[]).map(
          td => {
            const v = td.var;
            const vVal = get(values, v, '');
            const val = td.transform ? td.transform(vVal) : vVal;

            if (val && v && v.startsWith('locationPlan')) {
              //all location values
              const key = v.replace('locationPlan.', '');
              set(_location, key, val);
            } else if (val && v && v.startsWith('adminUser')) {
              //all user values
              const key = v.replace('adminUser.', '');
              set(user, key, val);
            } else if (val) {
              //all org values
              set(_org, v, val);
            }
          }
        );

        const title = uppercaseFirst(this.getTitle());

        if (!isEdit) {
          const shouldCreateAdmin = !this.props.form.getFieldValue(
            'adminUser.checked'
          );
          const hasLocation = get(values, 'locationPlan.checked');

          if (shouldCreateAdmin) {
            try {
              const userExists = await getUser(user.email);
              if (userExists) {
                // tslint:disable-next-line:max-line-length
                message.error('That user already exists. Please use a different email. ');
                return this.setState({
                  loading: false,
                });
              }
            } catch (err) {}
          }

          if (myOrg && myOrg.orgType === 0) {
            _org.serviceOrgId = myOrg.id;
          }

          if (hasLocation && orgType === 1) {
            set(_location, 'orgId', _org.id);
            // AER-1663: AntD6 (rc-field-form) stores dotted field names like
            // 'address.address' as FLAT literal keys, not the nested object that
            // AntD3 (rc-form) produced. Raw `values.address.address` therefore reads
            // `undefined.address` and throws "Cannot read properties of undefined
            // (reading 'address')" on Submit. Read via lodash `get`, which resolves
            // the flat dotted key (matching how the rest of this handler reads values).
            set(_location, 'address', {
              address: get(values, 'address.address'),
              zip: get(values, 'address.zip'),
              state: get(values, 'address.state'),
              city: get(values, 'address.city'),
              address2: get(values, 'address.address2'),
            });
            set(_location, 'name', this.state.locationName);
            set(_location, 'createdBy', me.userId);
            set(_location, 'updatedBy', me.userId);
            await createLocation(_location).then(() =>
              this.props.updateLocations()
            );
          }

          if (shouldCreateAdmin) {
            user.role = 2;
            user.userId = user.email;
            user.createdBy = me.userId;
            user.updatedBy = me.userId;
            user.orgId = _org.id;
            const Email = Emails.invite({ ToAddresses: [user.email] });
            await sendEmail(Email);
            await createUser(user);
          }
          _org.orgType = orgType;
          _org.updatedBy = me.userId;
          _org.createdBy = me.userId;

          // AER-1721: await it. The equipment writes inside were fired without being
          // awaited, so the org was created -- and the form navigated away -- while they
          // were still in flight. It still has to run BEFORE the deletes below: it reads
          // `_org.soPurchaseOrder` / `_org.doPurchaseOrder` off this object.
          await this.addEquipment(values, _org, _location);
          //these belong on the other properties or objects
          delete _org.soPurchaseOrder;
          delete _org.doPurchaseOrder;
          delete _org.subscriptionStart;
          delete _org.trialStart;
          delete _org.billingPreference;
          delete _org.addSubscription;
          delete _org.locationPlan;
          // AER-1725: onConsignment is an EQUIPMENT flag. The checkbox is rendered on this
          // org wizard (:408) and addEquipment() applies the answer to the equipment, which
          // is its only correct destination - but the org save carried the same form value
          // along, leaving it on 15 org records in each environment. Nothing reads it there.
          delete _org.onConsignment;
          await createOrg(_org).then(() => {
            this.props.updateOrgs();
          });

          message.success(`${title} Organization created Successfully`);
          trackEvent(eventTypes.org_add, { org: _org });

          // AER-1721: after the org exists, not before -- the push is minutes of device
          // traffic for a handful of handpieces, and the organization must not be left
          // uncreated behind it if the user closes the tab.
          this.syncAddedHandpieces(_org.id);
        } else if (isEdit && this.state.isAssignEquipment) {
          _org.updatedAt = new Date().toISOString();
          _org.updatedBy = me.userId;

          const added = await this.addEquipment(values, _org);
          const removed = await this.removeEquipment();
          if (size(added) || size(removed)) {
            trackEvent(eventTypes.eq_transfer, { added, removed });
          }
          //these belong on the other properties or objects
          delete _org.soPurchaseOrder;
          delete _org.doPurchaseOrder;
          delete _org.subscriptionStart;
          delete _org.trialStart;
          delete _org.billingPreference;
          delete _org.addSubscription;
          delete _org.locationPlan;
          // AER-1725: onConsignment is an EQUIPMENT flag. The checkbox is rendered on this
          // org wizard (:408) and addEquipment() applies the answer to the equipment, which
          // is its only correct destination - but the org save carried the same form value
          // along, leaving it on 15 org records in each environment. Nothing reads it there.
          delete _org.onConsignment;
          await updateOrg(_org).then(() => this.props.updateOrgs());

          message.success(`${title} Organization updated Successfully`);

          // AER-1721: as on the create path -- only the handpieces that ended up at a
          // location are pushed to, so on this path (which assigns no location) this is
          // normally a no-op.
          this.syncAddedHandpieces(_org.id);
        } else if (isEdit && !this.state.isAssignEquipment) {
          const acctNum = values.accountNumber;
          const hasDup = await this.checkForDupAcctNum(acctNum);
          if (hasDup) {
            return this.setState({ loading: false });
          }
          if (
            _org.orgType === 1 &&
            _org.serviceOrgId !== get(this.state, '_org.serviceOrgId')
          ) {
            const { eMap } = this.state;
            selectedEquipment.forEach((id: string) => {
              const e = eMap[id];
              set(e, 'updatedAt', moment().toISOString());
              set(e, 'updatedBy', me.userId);
              set(e, 'serviceOrgId', _org.serviceOrgId);
              createOrUpdateEquipment(e);
            });
          }
          _org.updatedAt = new Date().toISOString();
          _org.updatedBy = me.userId;
          //these belong on the other properties or objects
          delete _org.soPurchaseOrder;
          delete _org.doPurchaseOrder;
          delete _org.subscriptionStart;
          delete _org.trialStart;
          delete _org.billingPreference;
          delete _org.addSubscription;
          delete _org.locationPlan;
          // AER-1725: onConsignment is an EQUIPMENT flag. The checkbox is rendered on this
          // org wizard (:408) and addEquipment() applies the answer to the equipment, which
          // is its only correct destination - but the org save carried the same form value
          // along, leaving it on 15 org records in each environment. Nothing reads it there.
          delete _org.onConsignment;
          await updateOrg(_org).then(() => this.props.updateOrgs());
          trackEvent(eventTypes.org_update, { old: originalOrg, new: _org });
        }
        this.setState(
          {
            loading: false,
          },
          () => this.goBack(true)
        );
      } catch (err) {
        message.error('Save failed: ' + err.message);
        return this.setState({
          loading: false,
        });
      }
    });
  };

  onCheck = () => {
    setTimeout(() => {
      const trialStart = this.props.form.getFieldValue('trialStart');
      const subscriptionStart = moment(trialStart)
        .add(6, 'months')
        .add(1, 'day');
      if (trialStart) {
        this.props.form.setFieldsValue({ subscriptionStart });
      }
    }, 100);
  };

  //get the equipment that was selected and update it with new orgId
  // tslint:disable-next-line: no-any
  addEquipment = async (values: any, _org: Org, _location?: _Location) => {
    const {
      selectedEquipment,
      orgType,
      originalSelectedEquip,
      org,
    } = this.state;
    const { sState } = this.props;
    const me: any = get(sState, 'auth.user');
    const isEdit = org ? true : false;
    const equipmentToAdd = selectedEquipment.filter(
      (id: string) => !originalSelectedEquip.includes(id)
    );
    const { eMap } = this.state;
    // AER-1721: one at a time, and awaited. `.map(async ...)` returned before any of its
    // callbacks had finished, so `addEquipment` resolved immediately and the caller went
    // on to create the org and navigate away while the equipment writes -- and a device
    // command per handpiece -- were still running.
    this.handpiecesPendingSync = [];
    for (const id of equipmentToAdd as string[]) {
      let e = eMap[id] as Equipment;
      const equipHasSubHistory = hasSubHistory(e);
      const porderstring = `${orgType === 0 ? 'so' : 'do'}PurchaseOrder`;
      const _trialStart = values.trialStart;
      const trialStart = _trialStart
        ? moment(_trialStart).startOf('day')
        : undefined;
      const _subscriptionStart = values.subscriptionStart;
      const subscriptionStart = _subscriptionStart
        ? moment(_subscriptionStart).startOf('day')
        : undefined;
      const billingPreference = values.billingPreference;
      set(e, 'updatedAt', moment().toISOString());
      set(e, 'updatedBy', me.userId);
      set(e, `${orgType === 0 ? 'service' : 'dental'}OrgId`, _org.id);
      set(e, `${orgType === 0 ? 'SO' : 'DO'}SaleDate`, moment().toISOString());
      set(e, porderstring, _org[porderstring]);
      if (!!trialStart && !equipHasSubHistory && !e.alwaysSmart) {
        const { duration } = this.state.trialDuration;
        e = setTrialSub(e, trialStart, duration);
      }
      if (subscriptionStart && !equipHasSubHistory && !e.alwaysSmart) {
        e = setPayedSub(e, subscriptionStart, billingPreference);
      }
      // AER-1663: `locationPlan.checked` is a flat dotted key under AntD6, so raw
      // `values.locationPlan` is undefined. Read it via lodash `get` so transferred
      // equipment actually gets linked to the newly-created primary location.
      const addedPrimaryLocation = get(values, 'locationPlan.checked');
      if (!isEdit) {
        addedPrimaryLocation && _location && set(e, `locationId`, _location.id);
      }
      if (orgType === 1 && !e.serviceOrgId) {
        set(e, 'serviceOrgId', _org.serviceOrgId);
      }
      if (orgType === 0 || (orgType === 1 && addedPrimaryLocation)) {
        set(e, 'onConsignment', values.onConsignment);
      }
      try {
        await createOrUpdateEquipment(e);

        if (isHandpiece(e)) {
          //DEN-874 when HP is assigned to a dental school we need to send a command to the device telling it so
          if (e.deviceId) {
            try {
              await sendDeviceCommand(
                e.deviceId,
                {
                  arg: `{"cmd":"set_cfg", "cfg": {"config":{"dental_school":${orgType ===
                    1 && this.props.form.getFieldValue('doType') === 2}}}}`,
                },
                { showErrorToast: false },
                true
              );
            } catch (commandError) {
              // AER-1721: DEN-874's `dental_school` flag is a SEPARATE command from the
              // profile/preset configuration, and it must not be able to cancel it.
              // `sendDeviceCommand` rethrows even with `showErrorToast: false`, and it
              // used to share the outer try/catch below -- so a handpiece that was simply
              // powered off when it was added dropped out of the flow here and was never
              // sent any profiles or presets at all. That is the exact failure this ticket
              // is named for, and it is silent: the outer catch only console.warns.
              console.warn(commandError);
            }
          }

          // AER-1721: the push itself happens after the org has been written -- see
          // `syncAddedHandpieces`. Only a handpiece whose record was actually saved is
          // queued, so a failed write is still never followed by a push.
          this.handpiecesPendingSync.push(e);
        }
      } catch (error) {
        console.warn(error);
      }
    }
    return equipmentToAdd;
  };

  // AER-1721: push the location's profile/preset configuration to the handpieces that
  // were just assigned to it. The guard used to be `if (_location)` inside
  // `addEquipment`, and `_location` there is `new _Location()` -- a fresh object carrying
  // a generated id -- so on the create path it was truthy even when "Add Primary
  // Location" was left unchecked and no location had been created: every handpiece
  // transferred in was pushed against a location id that does not exist. Reading the id
  // back off each saved record instead makes it impossible to send one location's
  // settings to a handpiece sitting at another. The outcome is reported to the user as
  // well; it used to disappear into the `console.warn` above.
  //
  // AER-1722: started rather than awaited. Each handpiece is ~60 sequential device commands
  // and a transfer can carry many, so waiting meant an org save that appeared to hang for
  // minutes after the org itself had already been written. A device that is not reached is
  // recorded as out of sync server-side, so abandoning the wait no longer abandons the
  // knowledge; the per-location outcome toast still arrives if the app is still open.
  syncAddedHandpieces = (orgId: string) => {
    const byLocation: { [locationId: string]: Equipment[] } = {};
    this.handpiecesPendingSync.forEach(e => {
      const locationId = get(e, 'locationId', '') as string;
      if (!locationId) {
        return;
      }
      byLocation[locationId] = [...(byLocation[locationId] || []), e];
    });
    this.handpiecesPendingSync = [];

    const locationIds = Object.keys(byLocation);
    const total = locationIds.reduce(
      (sum, locationId) => sum + byLocation[locationId].length,
      0
    );

    for (const locationId of locationIds) {
      syncHandpiecesInBackground(
        byLocation[locationId],
        orgId,
        locationId,
        outcome => {
          if (outcome.ok) {
            message.success(outcome.text);
          } else {
            message.error(outcome.text);
          }
        }
      );
    }

    if (total > 0) {
      message.info(handpieceSyncStartedMessage(total));
    }
  };

  // check to see if equipment has been removed from the list
  //and remove orgId, locations, users etc.
  removeEquipment = () => {
    const {
      originalSelectedEquip,
      selectedEquipment,
      orgType,
      allUsers,
    } = this.state;
    const { sState } = this.props;
    const me: any = get(sState, 'auth.user');
    const equipmentToRemove = originalSelectedEquip.filter(
      (id: string) => !selectedEquipment.includes(id)
    );
    if (equipmentToRemove.length) {
      const { eMap } = this.state;
      equipmentToRemove.map((id: string) => {
        const e: Equipment = eMap[id];
        if (orgType === 0) {
          set(e, 'serviceOrgId', null);
        }
        set(e, 'dentalOrgId', null);
        set(e, 'groups', null);
        set(e, 'locationId', null);
        set(e, 'updatedAt', moment().toISOString());
        set(e, 'updatedBy', me.userId);

        createOrUpdateEquipment(e);
        let eqUsers = allUsers.filter((u: User) => {
          if (u.equipment) return u.equipment.includes(e.id as string);
          return false;
        });
        if (eqUsers.length) {
          eqUsers.forEach((user: User) => {
            user.equipment = get(user, 'equipment', []).filter(id => {
              return id !== e.id;
            });
            updateUser(user);
          });
        }
      });
    }
    return equipmentToRemove;
  };

  componentDidMount = () => {
    const {
      history: { location },
    } = this.props;

    this.retrieveData();
    const org = get(location, 'state.org');
    const screen = get(location, 'state.screen', 0);
    const orgType = get(location, 'state.orgType', 1);
    const back = get(
      location,
      'state.back',
      `< Back to Manage ${(orgType as any) === 0 ? 'Service' : 'Dental'} Orgs`
    );

    this.unblock = this.props.history.block(_nextLocation => {
      if (!this.state.canLeave) {
        this.state.nextLocation = _nextLocation;
        this.goBack();
        return false;
      }
    });

    this.setState(
      {
        org,
        orgType,
        screen,
        isAssignEquipment: screen > 0 ? true : false,
        back,
      },
      this.setFieldsOriginal
    );
  };
  unblock?: () => void;
  componentWillUnmount = () => {
    this.unblock && this.unblock();
  };
  getTitle = () => {
    const { orgType } = this.state;
    return orgType === 0 ? 'service' : 'dental';
  };
  retrieveData = async () => {
    this.setState({ loading: true });
    const {
      history: { location },
    } = this.props;

    const eqs: Equipment[] = await getEquipments();
    const allUsers = await getUsers();
    const models = await getModels();
    const allOrgs = await getOrgs();
    const trialDuration = await getAppSettings();
    const _org = get(location, 'state.org');
    const orgType = get(this, 'state.orgType', 1);
    const eMap = chain(eqs)
      .keyBy('deviceId')
      .value();
    const modelMap = chain(models)
      .keyBy('id')
      .value();

    const orgId = get(_org, 'id');
    const orgTitle = this.getTitle();
    const serviceOrgId = get(_org, 'serviceOrgId');
    const isEdit = !!this.state.org;
    const isDentalEZ = userHasRole([0, 1], this.props.sState);
    const isOrgAdmin = userHasRole(2, this.props.sState);
    const myOrgId = get(this.props, 'sState.auth.user.orgId');
    const selectedEquipment: Equipment[] = [];
    const equipment: Equipment[] = eqs
      .map(e => {
        const model = new _Model(get(modelMap, `${e.modelId}`, {}) as Model);

        return {
          ...e,
          key: e.deviceId,
          type: model.type,
          model: model.name,
        };
      })
      .filter(e => {
        if (orgId && get(e, `${orgTitle}OrgId`) == orgId) {
          selectedEquipment.push(e);
        }
        if (!e.showOnDash || !e.modelId || !e.equipmentSN) {
          return false;
        }
        if (orgType === 1) {
          if (isDentalEZ) {
            return (
              (serviceOrgId === e.serviceOrgId && !e.dentalOrgId) ||
              !e.serviceOrgId
            );
          } else if (!isEdit && isOrgAdmin) {
            return myOrgId === e.serviceOrgId && !e.dentalOrgId;
          } else {
            return serviceOrgId === e.serviceOrgId && !e.dentalOrgId;
          }
        } else {
          return !e.serviceOrgId;
        }
      });

    const originalSelectedEquip = sortBy(selectedEquipment, 'equipmentSN').map(
      e => e.deviceId
    );
    this.setState({
      loading: false,
      equipment: uniqBy([...equipment, ...selectedEquipment], 'deviceId'),
      selectedEquipment: originalSelectedEquip,
      originalSelectedEquip,
      allEquipment: eqs,
      allUsers,
      allOrgs,
      eMap,
      trialDuration,
    });
  };

  retrieveEquipment = async (id: string) => {
    const eqs: Equipment[] = await getEquipments();
    const models = await getModels();

    const modelMap = chain(models)
      .keyBy('id')
      .value();
    const equipment: Equipment[] = eqs
      .map(e => {
        const model = new _Model(get(modelMap, `${e.modelId}`, {}) as Model);
        return {
          ...e,
          key: e.deviceId,
          type: model.type,
          model: model.name,
        };
      })
      .filter(e => {
        if (!e.showOnDash || !e.modelId || !e.equipmentSN) {
          return false;
        }
        return (id === e.serviceOrgId && !e.dentalOrgId) || !e.serviceOrgId;
      });
    this.setState({ equipment });
  };
  setFieldsOriginal = () => {
    const { toDisplay, toDisplay1, toDisplay2, org, formValues } = this.state;
    const {
      form: { setFieldsValue },
    } = this.props;

    const flat = [...toDisplay, ...toDisplay1, ...toDisplay2];

    flatten(flat as TDisplay[]).map(item => {
      const val = get(org, `${item.var}`, get(formValues, item.var));
      if (val) {
        const v = item.type === 'datepicker' ? moment(val) : val;
        setFieldsValue({ [item.var]: v });
      }
    });
  };
  goBack = (force = false) => {
    const onOk = () => {
      const { nextLocation } = this.state;
      const { history } = this.props;
      this.state.canLeave = true;
      if (nextLocation) {
        history.push(nextLocation);
      } else {
        history.goBack();
      }
    };

    const onCancel = () => 0;

    const isEdit = this.state.org ? true : false;
    const title = this.state.orgType === 0 ? 'Service' : 'Dental';

    if (force) {
      onOk();
    } else {
      this.props.app.modal.confirm({
        title: 'Navigation Confirmation',
        content:
          // tslint:disable-next-line:max-line-length
          `Are you sure you want to navigate away from ${
            isEdit ? 'Edit' : 'Add'
          } ${title} Organization?  The ${
            isEdit ? '' : 'new'
          } ${title} Organization will not be ${
            isEdit ? 'saved' : 'created'
          } and any progress will be lost.`,
        onOk,
        onCancel,
        okText: 'Leave',
      });
    }
  };

  renderTitle = () => {
    const { org, orgType, screen } = this.state;

    const title = orgType === 0 ? 'Service' : 'Dental';

    let comp;
    if (org) {
      comp = <FormTitle>{`Edit ${title} Organization`}</FormTitle>;
    } else {
      const props = {
        cols: [
          { text: `${title} Information` },
          { text: 'Assign Equipment' },
          { text: 'Invite Admin User' },
        ],
        activeIndex: screen,
      };

      comp = (
        <React.Fragment>
          <FormTitle>{`Add ${title} Organization`}</FormTitle>
          <NumberedHeader {...props} />
        </React.Fragment>
      );
    }
    return <div css={css(`width: 80%; margin-top: 10px;`)}>{comp}</div>;
  };
  equipmentChange = (nextTargetKeys: Equipment[]) => {
    this.setState({ selectedEquipment: nextTargetKeys });
  };
  renderScreen = () => {
    const {
      toDisplay,
      toDisplay1,
      toDisplay2,
      screen,
      equipment,
      selectedEquipment,
    } = this.state;

    const { Form } = this.props.form;

    const eqs = sortBy(equipment, 'equipmentSN');

    if (screen === 0) {
      return (
        <Form
          layout="vertical"
          css={css(styles.formContainer)}
          onSubmit={this.submit}
          items={toDisplay}
        />
      );
    } else if (screen === 1) {
      return (
        <div css={css(styles.container, styles.formContainer)}>
          <TableTransfer
            dataSource={eqs}
            targetKeys={selectedEquipment}
            showSearch={true}
            onChange={this.equipmentChange}
            locale={{
              searchPlaceholder: 'Search by model or serial number',
              emptyText: (
                <span
                  css={css(`font-style: italic;`)}
                >{`No equipment assigned`}</span>
              ),
            }}
            filterOption={equipmentTransferFilterOption}
            leftColumns={equipmentTransferColumns}
            rightColumns={equipmentTransferColumns}
          />

          <Form
            layout="vertical"
            css={css(styles.formContainer2, 'margin-top: 10px;')}
            onSubmit={this.submit}
            items={toDisplay1}
          />
        </div>
      );
    } else {
      return (
        <Form
          layout="vertical"
          css={css(styles.formContainer2)}
          onSubmit={this.submit}
          items={toDisplay2}
        />
      );
    }
  };
  dir = (num: number) => {
    const { screen } = this.state;
    if (num > 0) {
      this.props.form.validateFieldsAndScroll(async (err: any) => {
        if (err) {
          const error = buildErrorMsgFromForm(err);
          this.setState({ loading: false });
          return message.error(error);
        }

        this.setState(
          {
            screen: screen + num,
          },
          this.setFieldsOriginal
        );
      });
    } else {
      this.setState({
        screen: screen + num,
      });
    }
  };

  checkForDupAcctNum = async (acctNum: string) => {
    const { orgType, org } = this.state;
    const isEdit = !!org ? true : false;
    if (!acctNum) {
      if (isEdit) {
        return false;
      }
      this.setState({ loading: false });
      return this.dir(1);
    }
    const allOrgs = await getOrgs();
    const dup = allOrgs.find(_org => {
      return (
        _org.orgType === orgType &&
        _org.accountNumber === acctNum &&
        get(org, 'id') !== get(_org, 'id')
      );
    });
    if (!!dup) {
      // AER-1693: this used the AntD3 (rc-form) object-map signature
      // `setFields({ accountNumber: { value, errors: [new Error(...)] } })`.
      // Under antd 6 (@rc-component/form) `setFields` takes an ARRAY of field
      // objects and `errors` must be `string[]`, so the old shape was silently
      // ignored: the duplicate still blocked "Next" (we return true below) but
      // no message ever attached to the field and the user was stuck with no
      // explanation. Use the array form so the error renders on Account ID.
      this.props.form.setFields([
        {
          name: 'accountNumber',
          value: this.props.form.getFieldValue('accountNumber'),
          errors: ['Organization with this Account Number already exists.'],
        },
      ]);
      this.setState({ loading: false });
      return true;
    } else {
      if (isEdit) {
        return false;
      } else {
        this.setState({ loading: false });
        this.dir(1);
      }
    }
  };

  renderButtons = () => {
    const { loading, screen, org, isAssignEquipment } = this.state;
    const { getFieldValue } = this.props.form;
    const checked = getFieldValue('adminUser.checked');
    const firstName = getFieldValue('adminUser.firstName');
    const lastName = getFieldValue('adminUser.lastName');
    const email = getFieldValue('adminUser.email');
    let buttons: ReactNode[] = [];

    const isEdit = org ? true : false;
    const cancel = (
      <Button
        title={'Cancel'}
        disabled={loading}
        css={css`
          margin: 0 5px;
        `}
        outline={true}
        onClick={() => this.goBack()}
      />
    );

    const prev = (
      <Button
        title={'Previous'}
        loading={loading}
        css={css`
          margin: 0 5px;
        `}
        onClick={() => this.dir(-1)}
      />
    );

    const next = (
      <Button
        title={'Next'}
        loading={!!loading}
        css={css`
          margin: 0 5px;
        `}
        onClick={async () => {
          this.setState({ loading: true });
          const accountNumber = this.props.form.getFieldValue('accountNumber');
          if (screen === 0) {
            return await this.checkForDupAcctNum(accountNumber);
          }
          this.setState({ loading: false });
          this.dir(1);
        }}
      />
    );

    const submit = (
      <Button
        title={'Submit'}
        loading={loading}
        css={css`
          margin: 0 5px;
        `}
        disabled={
          loading ||
          (screen === 2 && !checked && (!firstName || !lastName || !email))
        }
        onClick={this.submit}
        outline={false}
      />
    );

    if (isEdit && !isAssignEquipment) {
      buttons = [cancel, submit];
    } else if (screen === 0) {
      buttons = [cancel, next];
    } else if (screen === 1) {
      if (isEdit && isAssignEquipment) {
        buttons = [cancel, submit];
      } else {
        buttons = [prev, cancel, next];
      }
    } else {
      buttons = [prev, cancel, submit];
    }

    return (
      <div
        css={css(
          SharedStyles.row,
          screen === 0 ? `margin-top: 50px` : `margin-top: 20px;`
        )}
      >
        {buttons.map(b => b)}
      </div>
    );
  };

  render() {
    const { back } = this.state;
    return (
      <div css={css(styles.container)}>
        {!!back && (
          <Link
            css={css`
              margin-bottom: 5px;
              margin-right: auto;
            `}
            onClick={() => this.goBack()}
          >
            {back}
          </Link>
        )}

        {this.renderTitle()}

        {this.renderScreen()}

        {this.renderButtons()}
      </div>
    );
  }
}

export const EditOrgComponent = WithAppConfig(WithForm(withRouter(_EditOrgComponent)));
